import createReducer from './../lib/createReducer';
import * as types from './../actions/types';

export const WebchatReducre = createReducer(
  {
    webchatconfig: [],
  },
  {
    [types.GET_WEBCHAT_PREFERENCE_START](state) {
      const newState = Object.assign({}, state, {
        getWebpreference: true,
      });

      return newState;
    },
    [types.GET_WEBCHAT_PREFERENCE_FAIL](state) {
      const newState = Object.assign({}, state, {
        getWebpreference: false,
        webchatpreference: {},
      });

      return newState;
    },
    [types.GET_WEBCHAT_PREFERENCE_SUCCESS](state, actions) {
      const newState = Object.assign({}, state, {
        getWebpreference: false,
        webchatpreference: actions.webchatpreference,
      });

      return newState;
    },
    [types.POST_WEBCHAT_STATUS_SUCCESS](state, actions) {
      let temp = { ...state.webchatpreference };
      if (temp.channel_status) {
        temp.channel_status = actions.webchatstatus ? 'ENABLED' : 'DISABLED';
      }
      const newState = Object.assign({}, state, {
        getWebpreference: false,
        webchatpreference: temp,
      });

      return newState;
    },
    [types.POST_WEBCHAT_GREETING_START](state) {
      const newState = Object.assign({}, state, {
        getWebGreetings: true,
        logoSizeerror: false,
        uploadFail: false,
      });

      return newState;
    },
    [types.POST_WEBCHAT_GREETING_FAIL](state) {
      const newState = Object.assign({}, state, {
        getWebGreetings: false,
      });

      return newState;
    },
    [types.POST_WEBCHAT_GREETING_SUCCESS](state, actions) {
      console.log('cs', state);
      let temp = { ...state.webchatpreference };
      if (temp.greeting) {
        temp.greeting.greeting_message = actions.greeting.greeting_message;
        temp.greeting.first_message = actions.greeting.first_message;
      } else {
        temp.greeting = {};
        temp.greeting.greeting_message = actions.greeting.greeting_message;
        temp.greeting.first_message = actions.greeting.first_message;
      }

      const newState = Object.assign({}, state, {
        getWebGreetings: false,
        webchatpreference: temp,
      });

      return newState;
    },
    [types.POST_WEBCHAT_BRAND_SUCCESS](state, actions) {
      console.log('cs', state);
      let temp = { ...state.webchatpreference };
      if (temp.brand_personalization) {
        temp.brand_personalization = actions.branding;
      } else {
        temp.brand_personalization = {};
        temp.brand_personalization = actions.branding;
      }

      const newState = Object.assign({}, state, {
        getWebGreetings: false,
        webchatpreference: temp,
        logoSizeerror: false,
        uploadFail: false,
      });

      return newState;
    },
    [types.POST_WEBCHAT_EMAILPREF_SUCCESS](state, actions) {
      console.log('cs', state);
      let temp = { ...state.webchatpreference };
      if (temp.new_conversation_preference) {
        temp.new_conversation_preference = actions.emailpref;
      } else {
        temp.new_conversation_preference = {};
        temp.new_conversation_preference = actions.emailpref;
      }

      const newState = Object.assign({}, state, {
        getWebGreetings: false,
        webchatpreference: temp,
        logoSizeerror: false,
        uploadFail: false,
      });

      return newState;
    },
    [types.POST_WEBCHAT_COLLAPSE_SUCCESS](state, actions) {
      console.log('cs', state);
      let temp = { ...state.webchatpreference };
      if (temp.initial_state) {
        temp.initial_state = actions.collapse;
      } else {
        temp.initial_state = {};
        temp.initial_state = actions.collapse;
      }

      const newState = Object.assign({}, state, {
        getWebGreetings: false,
        webchatpreference: temp,
        logoSizeerror: false,
        uploadFail: false,
      });

      return newState;
    },
    [types.POST_WEBCHAT_EMAIL_SUCCESS](state, actions) {
      console.log('cs', state);
      let temp = { ...state.webchatpreference };
      // if(temp.initial_state){
      //   temp.initial_state = actions.collapse;
      // }else{
      //   temp.initial_state = {};
      //   temp.initial_state = actions.collapse;
      // }
      temp.email_preference = actions.email;

      const newState = Object.assign({}, state, {
        getEmailInst: false,
        webchatpreference: temp,
        logoSizeerror: false,
        uploadFail: false,
      });

      return newState;
    },
    [types.POST_WEBCHAT_EMAIL_START](state, actions) {
      const newState = Object.assign({}, state, {
        getEmailInst: true,
        logoSizeerror: false,
        uploadFail: false,
      });

      return newState;
    },
    [types.POST_WEBCHAT_EMAIL_FAIL](state, actions) {
      const newState = Object.assign({}, state, {
        getEmailInst: false,
        logoSizeerror: false,
        uploadFail: false,
      });

      return newState;
    },
    [types.POST_WEBCHAT_LOGO_SUCCESS](state, actions) {
      console.log('cs', state);
      let temp = { ...state.webchatpreference };
      if (temp.brand_personalization) {
        temp.brand_personalization.global_logo_file =
          actions.logo.data.global_logo_file;
        temp.brand_personalization.logo_file = actions.logo.data.file_name;
        temp.brand_personalization.file_name = actions.logo.data.file_name;
      } else {
        temp.brand_personalization = {};
        temp.brand_personalization.global_logo_file =
          actions.logo.data.global_logo_file;
        temp.brand_personalization.logo_file = actions.logo.data.file_name;
        temp.brand_personalization.file_name = actions.logo.data.file_name;
      }

      const newState = Object.assign({}, state, {
        getWebGreetings: false,
        webchatpreference: temp,
        logoSizeerror: false,
        uploadFail: false,
      });

      return newState;
    },
    [types.POST_WEBCHAT_LOGO_SIZE_ISSUE](state) {
      let temp = { ...state.webchatpreference };
      if (temp.brand_personalization) {
        temp.brand_personalization.global_logo_file = null;
        temp.brand_personalization.logo_file = null;
        temp.brand_personalization.file_name = null;
      } else {
        temp.brand_personalization = {};
        temp.brand_personalization.global_logo_file = null;
        temp.brand_personalization.logo_file = null;
        temp.brand_personalization.file_name = null;
      }
      const newState = Object.assign({}, state, {
        logoSizeerror: true,
        uploadFail: true,
        webchatpreference: temp,
        getWebGreetings: false,
      });

      return newState;
    },
    [types.POST_WEBCHAT_LOGO_FAIL](state) {
      const newState = Object.assign({}, state, {
        logoSizeerror: false,
        uploadFail: true,
        getWebGreetings: false,
      });

      return newState;
    },
  },
);
export { WebchatReducre as default };
